import { configureStore } from "@reduxjs/toolkit";
import MainSlice, { AssetsReducer } from "../Slices/MainSlice";

const rootReducer = {
  APIData: MainSlice,
  AssetsData: AssetsReducer
};

export const store = configureStore({
  reducer: rootReducer
});